<template>
    <div class="sport-carousel">
        <div class="sport-carousel__directions">
            <a class="sport-carousel__directions__btn sport-carousel__directions__btn--prev rounded-circle hidden" href="javascript:void(0)"
               @click="prev">
                <i class="fa fa-angle-left"></i>
            </a>
            <a class="sport-carousel__directions__btn sport-carousel__directions__btn--next rounded-circle" href="javascript:void(0)"
               @click="next">
                <i class="fa fa-angle-right"></i>
            </a>
        </div>
        <div class="sport-carousel__content"
             :style="{'width': 'calc(' + 100 * items.length / count + '% + '+ 20 * items.length / count + 'px)', 'marginLeft': 'calc(-' + 100 * active / count + '% - ' + 20 * active / count + 'px)'}">
            <div class="sport-carousel__content__item" v-for="(item, index) in items" :key="index"
                 :style="{'width': 100 / items.length + '%'}">
                <sport-course-card :course="item"></sport-course-card>
            </div>
        </div>
    </div>
</template>

<script>
    import SportCourseCard from '../sports/SportCourseCard';

    export default {
        name: 'sportcarousel',
        components: {
            SportCourseCard,
        },
        props: {
            countProp: {
                type: Number,
                default: 1
            },
            sport: {

            }
        },
        data() {
            return {
                active: 0,
                count: 4,
                items: {}
            }
        },
        mounted() {
            var self = this;

            this.$bus.$on('geolocalizated', function (args) {
                axios({
                    method: 'get',
                    url: '/courses_by_distance_by_sport?latitude=' +
                    args.latitude +
                    '&longitude=' +
                    args.longitude +
                    '&sport=' +
                    self.sport.id,
                }).then((response) => {
                    self.items = response.data;
                    if (self.items.length) {
                        $('#close-courses').removeClass('hidden');
                    }
                }).catch((error) => {
                    this.message = 'Error';
                });
            });

            this.resizeCount();

            window.addEventListener('resize', function () {
                self.resizeCount();
            });
        },
        methods: {
            resizeCount() {
                if (window.innerWidth <= 992)
                    this.count = 3;
                if (window.innerWidth <= 768)
                    this.count = 2;
            },
            prev() {
                if (this.items.length <= this.count) return;
                if (this.active === 0) {
                    this.active = this.items.length - this.count;
                } else {
                    this.active--;
                }
            },
            next() {
                if (this.items.length <= this.count) return;
                if (this.active === this.items.length - this.count) {
                    this.active = 0;
                } else {
                    this.active++;
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/sports/SportCarousel.vue